
// DEPRECATED: This reducer/action/function is not used anymore. Pleasre remove and test.

import { ADD_TOKEN, DELETE_TOKEN } from '../reducers/token';

export const addToken = (tokenId, patientId, expiry) => (dispatch) => {
  const obj = {
    token: tokenId,
    pId: patientId,
    expiry,
  };
  dispatch({
    type: ADD_TOKEN,
    payload: obj,
  });
};


export const deleteToken = (tokenObject, tokenList) => {
  tokenList.splice(tokenList.indexOf(tokenObject), 1);
  return (dispatch) => {
    dispatch({
      type: DELETE_TOKEN,
      payload: tokenList,
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/token.js